
import {map} from 'rxjs/operators';
import { EcaSecurityAuthenticationService } from './../../services/security-authentication/security-authentication.service';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { EcaWindowRefService } from '../../services/window-ref/window-ref.service';

@Injectable({
  providedIn: 'root'
})
export class EcaIsAuthenticatedGuard  {
  private _securityService = inject(EcaSecurityAuthenticationService);
  private _router = inject(Router);
  private _ecaWindowRefService = inject(EcaWindowRefService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const sessionStorage = this._ecaWindowRefService.nativeWindow.sessionStorage;
    return this._securityService.isAuthenticated().pipe(map(
      (authenticated) => {
        if (authenticated) {
          return true;
        } else {
          sessionStorage.setItem('eca_requested_route', state.url);
          this._router.navigateByUrl('/login');
          return false;
        }
      }
    ));
  }
}
